import { render, staticRenderFns } from "./WhereToBuyCreateEdit.vue?vue&type=template&id=4515ae29&"
import script from "./WhereToBuyCreateEdit.vue?vue&type=script&lang=js&"
export * from "./WhereToBuyCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./WhereToBuyCreateEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCheckbox,VIcon,VRadio,VRadioGroup,VTextField})
